import { render, staticRenderFns } from "./CustomerTypeFields.vue?vue&type=template&id=34a3d306&scoped=true"
import script from "./CustomerTypeFields.vue?vue&type=script&lang=js"
export * from "./CustomerTypeFields.vue?vue&type=script&lang=js"
import style0 from "./CustomerTypeFields.vue?vue&type=style&index=0&id=34a3d306&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a3d306",
  null
  
)

export default component.exports